import { useCallback, useMemo } from 'react';
import { fireGtm, useOnceGtm } from 'src/features/analytics/hooks/useGtm';

import { ProductListItem } from '../utils/productListItem';

type Params = {
    products: (string | ProductListItem)[];
    listName?: string;
    listId?: string;
};

/**
 * GTM events for the product list
 * @param params
 */
export const useProductListGtm = (params: Params) => {
    const { products } = params;

    /**
     * The event to fire only once
     */
    const itemEvent = useMemo(() => {
        return {
            event: 'eec.impressions' as const,
            eecEventName: 'Impression Views',
            ecommerce: {
                impressions: products.map((item, index) => {
                    if (typeof item !== 'string') {
                        return {
                            id: item.sku,
                            name: item.name,
                            price: item.price.price,
                            index: index,
                        };
                    }
                }),
            },
        };
    }, [products]);

    /**
     * Fire the one-time event
     */
    useOnceGtm(itemEvent);

    const gtmSelectItem = useCallback(
        (index: number) => {
            const product = products[index];
            if (typeof product !== 'string') {
                return fireGtm({
                    event: 'select_item',
                    ecommerce: {
                        impressions: [
                            {
                                id: product.sku,
                                name: product.name,
                                price: product.price.price,
                                index: index,
                            },
                        ],
                    },
                });
            }
        },
        [products],
    );

    return {
        gtmSelectItem,
    };
};
